import { Box, styled } from "@mui/material";

export const LoadingContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: `${theme.palette.core.white}66`,
}));
